const throwJsonAction = (message: string, options?: object) => {
  throw new Response(JSON.stringify({ message }), {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
};

export default throwJsonAction;
